// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 30px;
  border-radius: 16px;
}
.wrapper .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.wrapper .close-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.wrapper .close-icon:hover {
  background: #f2dbd9;
}
.wrapper .venue-name {
  font-size: 18px;
  text-transform: uppercase;
  font-family: AppFontMedium;
  padding: 0px 30px 25px;
  text-align: center;
  font-weight: bold;
}
.wrapper .title {
  font-size: 18px;
  text-transform: uppercase;
  font-family: AppFontMedium;
  padding: 0px 20px;
  text-align: center;
}
.wrapper .sub-title {
  font-size: 14px;
  padding: 20px;
  text-align: center;
  text-transform: uppercase;
  font-family: AppFontMedium;
}
.wrapper .wrapper-block {
  width: 100%;
  text-align: center;
}
.wrapper .wrapper-block h3 {
  font-size: 14px;
  padding: 20px;
  text-align: center;
  text-transform: uppercase;
  font-family: AppFontMedium;
}
.wrapper .wrapper-block .show-time {
  padding: 10px 20px;
  width: 100%;
  background: #F6F1EF;
  border-radius: 26px;
  text-align: center;
  text-transform: uppercase;
  font-family: AppFontMedium;
  cursor: pointer;
}
.wrapper ion-button {
  width: 100%;
  padding-top: 20px;
}
.wrapper ion-button:hover {
  --background: var(--primary-btn) !important;
}

.time-selection-wrapper {
  padding: 0px;
  width: 100%;
  padding-bottom: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/before-create-order-select-time-dialog/before-create-order-select-time-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AACJ;AAAC;EAEO,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AACR;AAAQ;EACI,WAAA;EACA,YAAA;EACA,WAAA;AAEZ;AAAQ;EACI,mBAAA;AAEZ;AACI;EACI,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,sBAAA;EACJ,kBAAA;EACA,iBAAA;AACJ;AACI;EACI,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,iBAAA;EACJ,kBAAA;AACJ;AACI;EACI,eAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,0BAAA;AACR;AACI;EACI,WAAA;EACA,kBAAA;AACR;AAAQ;EACI,eAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,0BAAA;AAEZ;AAAQ;EACI,kBAAA;EACA,WAAA;EACJ,mBAAA;EAEI,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,0BAAA;EACA,eAAA;AACZ;AAEI;EACI,WAAA;EACA,iBAAA;AAAR;AACQ;EACI,2CAAA;AACZ;;AAGA;EAGI,YAAA;EACA,WAAA;EACA,mBAAA;AAFJ","sourcesContent":[".wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    padding: 30px;\n    border-radius: 16px;\n\t.close-icon {\n\n        position: absolute;\n        top: 15px;\n        right: 15px;\n        margin: 0px;\n        background: var(--color-white-accent);\n        width: 35px;\n        height: 35px;\n        padding: 0px;\n        z-index: 99;\n        ion-icon {\n            width: 100%;\n            height: 100%;\n            margin: 0px;\n        }\n        &:hover {\n            background: #f2dbd9;\n        }\n    }\n    .venue-name {\n        font-size: 18px;\n        text-transform: uppercase;\n        font-family: AppFontMedium;\n        padding: 0px 30px 25px;\n    text-align: center;\n    font-weight: bold;\n    }\n    .title {\n        font-size: 18px;\n        text-transform: uppercase;\n        font-family: AppFontMedium;\n        padding: 0px 20px;\n    text-align: center;\n    }\n    .sub-title {\n        font-size: 14px;\n        padding: 20px;\n        text-align: center;\n        text-transform: uppercase;\n        font-family: AppFontMedium;\n    }\n    .wrapper-block {\n        width: 100%;\n        text-align: center;\n        h3 {\n            font-size: 14px;\n            padding: 20px;\n            text-align: center;\n            text-transform: uppercase;\n            font-family: AppFontMedium;\n        }\n        .show-time {\n            padding: 10px 20px;\n            width: 100%;\n        background: #F6F1EF\n        ;\n            border-radius: 26px;\n            text-align: center;\n            text-transform: uppercase;\n            font-family: AppFontMedium;\n            cursor: pointer;\n        }\n    }\n    ion-button {\n        width: 100%;\n        padding-top: 20px;\n        &:hover {\n            --background:  var(--primary-btn)  !important;\n        }\n    }\n}\n.time-selection-wrapper {\n\n\n    padding: 0px;\n    width: 100%;\n    padding-bottom: 0px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
